import { Home } from './Home';

export class Youppi extends Home {

    private _elRecettes : HTMLElement;
    private _elHero     : HTMLElement;
    private _elStripes  : HTMLElement;
    private _elTitle    : HTMLElement;
    private _elYouppi   : HTMLElement;
    private _elGlass    : HTMLElement;

    constructor() {
        super();


        this._elRecettes = document.querySelector('.s_recettes') as HTMLElement;
        this._elHero = document.querySelector('.youppi_hero') as HTMLElement;
        this._elStripes = this._elHero.querySelector('.ch_container') as HTMLElement;
        this._elTitle = this._elHero.querySelector('h2') as HTMLElement;
        this._elYouppi = this._elHero.querySelector('img.youppi') as HTMLElement;
        this._elGlass = this._elHero.querySelector('img.glass') as HTMLElement;

        this._elHero.classList.remove('js_visibility_hidden');  

        TweenMax.set(this._elHero, {opacity:0});
        TweenMax.set(this._elTitle, {opacity:0});
        TweenMax.set(this._elGlass, {scale:0});
        TweenMax.set(this._elYouppi, {scale:0});
        if (this._elRecettes) {
            TweenMax.set(this._elRecettes, {opacity:0});
            this._elRecettes.classList.remove('js_visibility_hidden');  
        }
        TweenMax.to(this._elHero, 1.7, {opacity: 1, ease: Expo.easeOut});
        TweenMax.fromTo(this._elStripes, 0.4, {x: "-100%"}, {x:"0%", clearProps:"all", ease: Expo.easeIn})
        TweenMax.to(this._elGlass, 0.6, {scale: 1, delay: 1, clearProps:"all", ease: Expo.easeOut})
        TweenMax.to(this._elTitle, 0.6, {opacity: 1, delay: 1.2, ease: Expo.easeOut})
        if (this._elRecettes) TweenMax.to(this._elRecettes, 0.6, {opacity: 1, delay: 1.3, ease: Expo.easeOut})
        TweenMax.to(this._elYouppi, 0.6, {scale: 1, delay: 1.6, clearProps:"all", ease: Expo.easeOut})

        // if (typeof (document.documentElement.style as any).objectFit == 'undefined') {
            // this._fixObjectFit();
            // window.addEventListener('resize', this._fixObjectFit.bind(this), false);
        // }
    }

    // private _fixObjectFit() {
    //     var container = this._elRecettes.querySelector('.image_wrapper') as HTMLElement;
    //     var image = this._elRecettes.querySelector('.thumbnail') as HTMLElement;

    //     var container_w = this._elRecettes.offsetWidth;
    //     var container_h = this._elRecettes.offsetHeight
    
    //     // use largest scale factor of horizontal/vertical
    //     var scale_w = container_w / 461;
    //     var scale_h = container_h / 653;
    //     var scale = (scale_w > scale_h) ? scale_w : scale_h;

    //     // scale the video
    //     image.style.width = (scale * 461)+"px";
    //     image.style.height = (scale * 653)+"px";

    // }

}